export interface InventoryUnit {
  value: string
  label: string
}

export const INVENTORY_UNITS: InventoryUnit[] = [
  { value: 'items', label: 'Items' },
  { value: 'dozens', label: 'Dozens' },
  { value: 'boxes', label: 'Boxes' },
  { value: 'trays', label: 'Trays' },
  { value: 'loaves', label: 'Loaves' },
  { value: 'kg', label: 'Kilograms' },
]
